export default "__VITE_ASSET__C_tkFI2Y__"